// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
import { ReportingLines } from './main';
export { ReportingLinesSkeleton } from './ReportingLines/Skeleton';

export default ReportingLines;
